var _path, _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 31,
    viewBox: "0 0 42 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.45931 23.7475C2.00239 24.2044 2.00239 24.9452 2.45931 25.4021C2.91622 25.859 3.65702 25.859 4.11394 25.4021L2.45931 23.7475ZM17.0688 10.7926L17.8961 9.9653C17.4392 9.50839 16.6984 9.50839 16.2415 9.9653L17.0688 10.7926ZM24.1822 17.906L23.3549 18.7333C23.8118 19.1902 24.5526 19.1902 25.0095 18.7333L24.1822 17.906ZM41.9925 1.26575C41.9925 0.619574 41.4687 0.0957471 40.8225 0.0957471H30.2925C29.6463 0.0957471 29.1225 0.619574 29.1225 1.26575C29.1225 1.91192 29.6463 2.43575 30.2925 2.43575H39.6525V11.7957C39.6525 12.4419 40.1763 12.9657 40.8225 12.9657C41.4687 12.9657 41.9925 12.4419 41.9925 11.7957V1.26575ZM4.11394 25.4021L17.8961 11.6199L16.2415 9.9653L2.45931 23.7475L4.11394 25.4021ZM16.2415 11.6199L23.3549 18.7333L25.0095 17.0787L17.8961 9.9653L16.2415 11.6199ZM25.0095 18.7333L41.6498 2.09306L39.9952 0.438432L23.3549 17.0787L25.0095 18.7333Z",
    fill: "url(#paint0_linear_203_1643)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_203_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8146 13.1229C16.9718 13.2137 17.1655 13.2137 17.3227 13.1229L18.7397 12.3048C18.8969 12.214 18.9938 12.0463 18.9938 11.8648V10.2285C18.9938 10.047 18.8969 9.87928 18.7397 9.78851L17.3227 8.9704C17.1655 8.87963 16.9718 8.87963 16.8146 8.9704L15.3976 9.78851C15.2404 9.87928 15.1435 10.047 15.1435 10.2285V11.8648C15.1435 12.0463 15.2404 12.214 15.3976 12.3048L16.8146 13.1229Z",
    fill: "url(#paint1_linear_203_1643)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_203_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9279 19.7282C24.0851 19.819 24.2788 19.819 24.436 19.7282L25.853 18.9101C26.0102 18.8194 26.107 18.6516 26.107 18.4701V16.8339C26.107 16.6523 26.0102 16.4846 25.853 16.3938L24.436 15.5757C24.2788 15.4849 24.0851 15.4849 23.9279 15.5757L22.5109 16.3938C22.3536 16.4846 22.2568 16.6523 22.2568 16.8339V18.4701C22.2568 18.6516 22.3536 18.8194 22.5109 18.9101L23.9279 19.7282Z",
    fill: "url(#paint2_linear_203_1643)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_203_1643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.96889 26.5876C3.12609 26.6783 3.31978 26.6783 3.47699 26.5876L4.89401 25.7695C5.05121 25.6787 5.14806 25.511 5.14806 25.3294V23.6932C5.14806 23.5117 5.05121 23.3439 4.89401 23.2532L3.47699 22.4351C3.31978 22.3443 3.12609 22.3443 2.96889 22.4351L1.55187 23.2532C1.39466 23.3439 1.29782 23.5117 1.29782 23.6932V25.3294C1.29782 25.511 1.39466 25.6787 1.55187 25.7695L2.96889 26.5876Z",
    fill: "url(#paint3_linear_203_1643)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_203_1643",
    x: 14.0003,
    y: 7.75909,
    width: 8.42299,
    height: 8.86156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14322,
    dy: 1.14322
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14322
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_1643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_1643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_203_1643",
    x: 21.1136,
    y: 14.3644,
    width: 8.42299,
    height: 8.86156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14322,
    dy: 1.14322
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14322
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_1643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_1643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_203_1643",
    x: 0.154627,
    y: 21.2237,
    width: 8.42299,
    height: 8.86156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.14322,
    dy: 1.14322
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.14322
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_203_1643"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_203_1643",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_1643",
    x1: 40.8225,
    y1: 1.26575,
    x2: 3.28662,
    y2: 1.26575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#90278F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B491FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_1643",
    x1: 17.0686,
    y1: 13.2696,
    x2: 17.0686,
    y2: 8.82372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_203_1643",
    x1: 24.1819,
    y1: 19.8749,
    x2: 24.1819,
    y2: 15.429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_203_1643",
    x1: 3.22294,
    y1: 26.7343,
    x2: 3.22294,
    y2: 22.2884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F36EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90278F"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoing);
export default __webpack_public_path__ + "static/media/doing.dab773833c3d90d7767ee95807a309d6.svg";
export { ForwardRef as ReactComponent };